export default "__VITE_ASSET__CCZPhkeI__"